"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HorizontalLabel_1 = require("./HorizontalLabel");
exports.HorizontalLabel = HorizontalLabel_1.HorizontalLabel;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0hvcml6b250YWxMYWJlbC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHFEQUFpRDtBQUF6Qyw0Q0FBQSxlQUFlLENBQUEifQ==